import React from 'react';
import CSS from 'react-css-modules';

import eineLogo from 'assets/images/eine_logo.png';

import styles from './style.scss';

class Footer extends React.Component {
  render() {
    return (
      <div styleName="footer">
        <div>
          <img src={eineLogo} alt="로고" />
          <p>서울특별시 강남구 삼성로 571 K빌딩 8층 | 사업자등록번호: 591-81-00825 | (주) 아이네블루메 대표이사 최재현</p>
          <p><a href="tel:02-501-2268">Tel:02-501-2268</a> ㅣ <a href="mailto:help@chatie.me">Email:help@chatie.me</a></p>
          <span>Copyright © EINEBLUME CO., LTD. 2022 All Rights Reserved</span>
        </div>
      </div>
  );
}
}

const Component = CSS(Footer, styles);

export default Component;



// WEBPACK FOOTER //
// ./src/app/components/common/Footer/index.js